import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import {
  fetchDepartureAreasAsync,
  fetchPlacesOfStayAsync,
  fetchSearchAreaResponseByAccommodationAreaAsync,
  fetchSearchAreaResponseByDepartureAreaAsync,
} from './actions';

import type {
  DeparturePlace,
  SearchAreasErrors,
  SearchAreaAccommodations,
} from 'SearchAreas-Types';
export const isFetching = createReducer(false as boolean)
  .handleAction(
    [
      fetchDepartureAreasAsync.request,
      fetchSearchAreaResponseByAccommodationAreaAsync.request,
      fetchPlacesOfStayAsync.request,
      fetchSearchAreaResponseByDepartureAreaAsync.request,
    ],
    () => true,
  )
  .handleAction(
    [
      fetchDepartureAreasAsync.success,
      fetchDepartureAreasAsync.failure,
      fetchSearchAreaResponseByAccommodationAreaAsync.success,
      fetchSearchAreaResponseByAccommodationAreaAsync.failure,
      fetchPlacesOfStayAsync.success,
      fetchPlacesOfStayAsync.failure,
      fetchSearchAreaResponseByDepartureAreaAsync.success,
      fetchSearchAreaResponseByDepartureAreaAsync.failure,
    ],
    () => false,
  );

export const departureAreas = createReducer([] as Array<DeparturePlace>)
  .handleAction(fetchDepartureAreasAsync.success, (_state, action) => action.payload)
  .handleAction(
    [
      fetchSearchAreaResponseByAccommodationAreaAsync.success,
      fetchSearchAreaResponseByDepartureAreaAsync.success,
    ],
    (_state, action) => action.payload.departures,
  );

export const placesOfStay = createReducer({} as SearchAreaAccommodations)
  .handleAction(fetchPlacesOfStayAsync.success, (_state, action) => action.payload)
  .handleAction(
    [
      fetchSearchAreaResponseByDepartureAreaAsync.success,
      fetchSearchAreaResponseByAccommodationAreaAsync.success,
    ],
    (_state, action) => action.payload.accommodations,
  );

export const errors = createReducer([] as SearchAreasErrors[]).handleAction(
  [
    fetchDepartureAreasAsync.failure,
    fetchSearchAreaResponseByAccommodationAreaAsync.failure,
    fetchPlacesOfStayAsync.failure,
    fetchSearchAreaResponseByDepartureAreaAsync.failure,
  ],
  (_state, action) => action.payload,
);

const searchAreasReducer = combineReducers({
  isFetching,
  departureAreas,
  placesOfStay,
  errors,
});

export default searchAreasReducer;
export type SearchAreasState = ReturnType<typeof searchAreasReducer>;
